<template>
    <transition name="fade">
        <teleport to="body">
            <div
                class="citation-pdf-container d-flex flex-column"
                v-if="!!(visible && currentPdfFile)"
                :style="pdfPosition"
            >
                <div
                    class="d-flex flex-row justify-content-between align-items-center"
                >
                    <h3
                        class="text-truncate"
                        style="padding-right: var(--space-10)"
                    >
                        {{ pdfFrameTitle }}
                    </h3>
                    <div class="d-flex flex-row gap-2">
                        <button
                            class="icon-btn icon-btn-white"
                            @click="viewPdfInNewWindow"
                        >
                            <i class="fi fi-external-link"></i>
                        </button>
                        <button
                            class="icon-btn icon-btn-white"
                            @click="closePdf"
                        >
                            <i class="fi fi-x"></i>
                        </button>
                    </div>
                </div>
                <div class="pdf-viewer">
                    <Pdf
                        v-if="currentPdfFile"
                        :hash="currentPdfFile.hash"
                        :initial-page="currentPdfFile.page_number || 1"
                    />
                </div>
            </div>
        </teleport>
    </transition>
</template>

<script>
import Pdf from './pdf.vue';

export default {
    name: 'PdfViewerSidekick',
    components: {
        Pdf,
    },
    props: {
        visible: {
            type: Boolean,
            required: true,
        },
        currentPdfFile: {
            type: Object,
            required: false,
            default: null,
        },
    },
    computed: {
        pdfFrameTitle() {
            if (this.currentPdfFile?.original_filename) {
                return this.currentPdfFile.original_filename;
            }
            return 'PDF Viewer';
        },
        pdfPosition() {
            const height =
                this.$isTablet || this.$isMobile
                    ? window.innerHeight - 20 * 2 - 200 // 20px for padding, 200px for the iframe height in mobile view &
                    : window.innerHeight - 20 * 2; // 20px for padding
            const avaliableWidth = window.innerWidth - 540; // 500 - sidepanel width and 20px for padding - left and right
            const width = Math.min(avaliableWidth, 600); // 600px is the max width of the iframe

            if (this.$isMobile) {
                return {
                    top: '4rem',
                    height: `${height}px`,
                    left: '20px',
                    right: '20px',
                };
            }

            if (this.$isTablet) {
                return {
                    top: '4rem', // 4rem to account for the topbar of sidepanel
                    height: `${height}px`,
                    right: '20px', // 20px for padding right
                    width: `${500}px`, // 500px is the width of the sidepanel
                };
            }

            return {
                right: '520px',
                top: '1.25rem',
                bottom: '1.25rem',
                height: `${height}px`,
                width: `${width}px`,
            };
        },
    },
    emits: ['close-pdf'],
    methods: {
        closePdf() {
            this.$emit('close-pdf');
        },
        viewPdfInNewWindow() {
            if (!this.currentPdfFile) return;
            const routeData = this.$router.resolve({
                name: 'PdfViewer',
                params: {
                    hash: this.currentPdfFile.hash,
                },
                query:
                    this.currentPdfFile.page_number &&
                    this.currentPdfFile.page_number !== 1
                        ? { page: this.currentPdfFile.page_number }
                        : {},
            });
            window.open(routeData.href, '_blank');
            this.closePdf();
            return;
        },
    },
};
</script>

<style scoped>
.citation-pdf-container {
    position: fixed;
    height: 100%;
    z-index: 9999;
    background-color: var(--primary-25);
    border-radius: var(--radius-lg);
    padding-inline: var(--space-6);
    padding-block: var(--space-4);
    gap: var(--space-4);
}

/* Fade transition */
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s ease-in-out;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}

.fade-enter-to,
.fade-leave-from {
    opacity: 1;
}

.pdf-viewer {
    flex: 1;
    overflow-y: auto;
    overflow-x: hidden;
    height: 0;
    border: 1px solid var(--neutral-600);
}
</style>
